import store from "../../..";
import * as types from "../mutationTypes";

export default class Trees {
  toggleTeamPermission(clickedTeam, teamPermissions, teams) {
    this.tooglePermission(clickedTeam, teamPermissions, this.setTeamsPermission.bind(new Trees()), teams);
  }
  toggleCategories(clickedCategory, surveycategories, allCategories) {
    this.tooglePermission(clickedCategory, surveycategories, this.setCategories.bind(new Trees()), allCategories);
  }

  removeAllCategories(catUUID, tree) {
    tree.forEach((category) => {
      if (category.uuid === catUUID) {
        if (!category.interaction_count && !category.answer_count) {
          if (checkIfChildrenAreEnable(category.children)) {
            this.removeCategory(catUUID);
          }
        }
      } else if (category.children) {
        this.removeAllCategories(catUUID, category.children);
      }
    });
  }
  setTeamsPermission(teamId, isChecked) {
    if (isChecked) {
      this.addTeam(teamId);
    } else {
      this.removeTeam(teamId);
    }
  }
  setCategories(categoryId, isChecked) {
    if (isChecked) {
      this.addCategory(categoryId);
    } else {
      this.removeCategory(categoryId);
    }
  }
  addTeam(teamId) {
    if (store.state.survey.teamsPermission.includes(teamId)) {
      return;
    }
    const newSelectedTeams = [...store.state.survey.teamsPermission];
    const teamsPermission = newSelectedTeams.concat(teamId);
    store.commit("survey/" + types.SET_TEAMS_PERMISSION, { teamsPermission });
  }
  removeTeam(teamId) {
    if (!store.state.survey.teamsPermission.includes(teamId)) {
      return;
    }
    const teamsPermission = store.state.survey.teamsPermission.filter((team) => team !== teamId);
    store.commit("survey/" + types.SET_TEAMS_PERMISSION, { teamsPermission });
  }
  addCategory(categoryId) {
    if (store.state.survey.categories.includes(categoryId)) {
      return;
    }
    const categories = [...store.state.survey.categories];
    categories.push(categoryId);
    store.commit("survey/" + types.SET_CATEGORIES, { categories });
  }
  removeCategory(categoryId) {
    if (!store.state.survey.categories.includes(categoryId)) {
      return;
    }
    const categories = store.state.survey.categories.filter((catId) => catId !== categoryId);
    store.commit("survey/" + types.SET_CATEGORIES, { categories });
  }
  /**
   * Function that will update array of selected items
   * if the node is child and has parent, select the parent
   * if node is parent and will remove, remove the childs
   *
   * @param {Checkbox item clicked} clickedItem
   * @param {Array of selected items (teams or categories)} selectedItemsArray
   * @param {Function that will update checkbox and itens list} updateFunction
   * @param {Array of all items (teams or categories)} arrayFlat
   */
  tooglePermission(clickedItem, selectedItemsArray, updateFunction, arrayFlat) {
    // This flag will represent the state user wants for the category
    // isChecked = true, user is adding the category
    // isChecked = false, user is removing the category
    const isChecked = !selectedItemsArray.includes(clickedItem.uuid);

    // Toggle the clicked category
    updateFunction(clickedItem.uuid, isChecked, updateFunction);

    // If the user is toggling a team with parent, add/remove the parent tree recursively
    if (isChecked && clickedItem.parent_uuid) {
      this.toggleAllParents(clickedItem, isChecked, updateFunction, arrayFlat);
    }

    // If the user is removing a team with children, remove the childrens from selection recursively
    if (!isChecked && clickedItem.children) {
      this.toggleAllChildren(clickedItem, isChecked, updateFunction);
    }
  }
  /**
   * Toggle all parents of the child node
   *
   * @param {node selected} node
   * @param {if is checked or not} isChecked
   * @param {function that will update the array of selected items} updateFunction
   * @param {array of all items} arrayFlat
   */
  toggleAllParents(node, isChecked, updateFunction, arrayFlat) {
    if (!node.parent_uuid) return;

    updateFunction(node.parent_uuid, isChecked);
    const nextNode = arrayFlat.find((t) => t.uuid === node.parent_uuid);
    // check if this team has a parent before calling again
    nextNode && this.toggleAllParents(nextNode, isChecked, updateFunction, arrayFlat);
  }

  /**
   * Toggle all children of node, if is removing the node
   * All child must be removed too
   *
   * @param {node selected} node
   * @param {if is checked or not} isChecked
   * @param {function that will update the array of selected items} updateFunction
   */
  toggleAllChildren(node, isChecked, updateFunction) {
    if (!node.children) return;

    node.children.forEach((child) => {
      updateFunction(child.uuid, isChecked);
      this.toggleAllChildren(child, isChecked, updateFunction);
    });
  }
}

function checkIfChildrenAreEnable(children) {
  if (!children) {
    return true; // Dont have children and remove node
  }
  for (let i = 0; i < children.length; i++) {
    const category = children[i];
    if (category.interaction_count || category.answer_count) {
      return false;
    }
  }

  return true;
}
